import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { AlertModalContentComponent } from '../alert-modal-content/alert-modal-content.component';

@Component({
    selector: 'lib-alert-modal-content-errors',
    standalone: true,
    imports: [CommonModule, AlertModalContentComponent],
    templateUrl: './alert-modal-content-errors.component.html'
})
export class AlertModalContentErrorsComponent implements OnInit {
    @Input() errors: unknown;
    formattedErrors: string | null = null;

    ngOnInit(): void {
        this.formattedErrors = this.getValueFromObjectArrayString(
            this.errors,
            'There was an error. Please try again later.'
        );
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private getValueFromObjectArrayString(value: any, defaultMessage?: string) {
        if (value?.message) {
            return value.message;
        }

        if (value && typeof value !== 'string' && Object.keys(value).length > 0) {
            return Object.keys(value)
                .reduce((acc: string, error: string) => {
                    const string = Array.isArray(value[error]) ? value[error].join(' ') : value[error];
                    return acc + string + ' ';
                }, '')
                .trim();
        }

        if (typeof value === 'string') {
            return value;
        }

        if (defaultMessage) {
            return defaultMessage;
        }

        return null;
    }
}
